var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topbar"},[_c('a',{staticClass:"topbar-logo"}),_c('div',{staticClass:"topbar-menu",class:{'topbar-menu-opened' : _vm.getMenuState},on:{"click":function($event){return _vm.setMenuState()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }